import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Entiendes algo… pero cuando hablas te quedas en blanco.', 'Estudias "reglas" y al día siguiente se te olvida.', 'Conoces palabras sueltas, pero no sabes usarlas en frases.', 'Te frustra no sonar natural.', 'Empiezas motivado y abandonas a la semana.'];
export function ProblemSection() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-129">
          Si te pasa al menos una de estas, este pack es para ti:
        </h2>

        <ul className="space-y-3 mb-6" data-id="element-130">
          {problems.map((problem, index) => <li key={index} className="flex items-start gap-3" data-id="element-131">
              <XCircleIcon className="w-6 h-6 text-[#EF4444] flex-shrink-0 mt-0.5" data-id="element-132" />
              <span className="text-lg text-[#4A4A5A]" data-id="element-133">{problem}</span>
            </li>)}
        </ul>

        <div className="bg-white p-6 rounded-xl border-l-4 border-[#FF6B00]" data-id="element-134">
          <p className="text-lg md:text-xl text-[#1A1A2E] font-semibold mb-2" data-id="element-135">
            No es falta de inteligencia.
          </p>
          <p className="text-lg text-[#4A4A5A]" data-id="element-136">
            Es falta de un sistema simple que te haga practicar lo que SÍ se
            usa.
          </p>
        </div>
      </div>
    </section>;
}